const languageMetadata = {
  "Bamoun [Shupamom] (Audio)": [
    "bamoun",
    "shupamom",
    "bamileke",
    "west",
    "cameroon",
    "cameroon west",
    "grassfields",
  ],
  Basaa: [
    "basaa",
    "bassa",
    "sawa",
    "littoral",
    "cameroon",
    "douala",
    "sanaga",
  ],
  "Chichewa (Audio)": [
    "chichewa",
    "chewa",
    "nyanja",
    "malawi",
    "zambia",
    "mozambique",
  ],
  "Duala [Douala] (Audio)": [
    "duala",
    "douala",
    "sawa",
    "littoral",
    "cameroon",
    "wouri",
    "douala city",
  ],
  Ewe: ["ewe", "togo", "ghana", "benin", "volta"],
  Ewondo: [
    "ewondo",
    "beti",
    "beti-fang",
    "yaounde",
    "centre",
    "cameroon",
    "equatorial guinea",
    "equatorial",
    "guinea",
    "gabon",
    "fang",
  ],
  "Fulfulde (Benin) (Audio)": [
    "fulfulde",
    "fulani",
    "peul",
    "peulh",
    "foulfoulde",
    "benin",
    "borgou",
    "northern benin",
  ],
  "Fulfulde (Nigeria)": [
    "fulfulde",
    "fulani",
    "peul",
    "peulh",
    "foulfoulde",
    "nigeria",
    "northern nigeria",
    "adamawa",
  ],
  Ghomala: [
    "ghomala",
    "bamileke",
    "west",
    "cameroon",
    "bafoussam",
  ],
  Hausa: [
    "hausa",
    "haoussa",
    "nigeria",
    "niger",
    "cameroon",
    "sahel",
    "northern nigeria",
  ],
  "Igbo (Audio)": [
    "igbo",
    "ibo",
    "nigeria",
    "southeast nigeria",
  ],
  "Kikongo (Kituba)": [
    "kikongo",
    "kituba",
    "kongo",
    "congo",
    "republic of the congo",
    "drc",
    "dr congo",
    "congo-kinshasa",
    "congo-brazzaville",
  ],
  Kinyarwanda: ["kinyarwanda", "rwanda", "burundi", "kigali"],
  "Lingala (Audio)": [
    "lingala",
    "congo",
    "drc",
    "dr congo",
    "congo-kinshasa",
    "congo-brazzaville",
    "kinshasa",
    "brazzaville",
  ],
  Medumba: [
    "medumba",
    "bamileke",
    "west",
    "cameroon",
    "bangangte",
    "Mbetbo",
  ],
  "Nufi (Audio)": [
    "nufi",
    "nufi language",
    "bamileke",
    "west",
    "cameroon",
    "bafang",
    "bana",
    "fe'efe'e",
    "fe'fe'",
    "Tchamda",
  ],
  "Swahili (Audio)": [
    "swahili",
    "kiswahili",
    "tanzania",
    "kenya",
    "uganda",
    "dr congo",
    "drc",
    "east africa",
    "zanzibar",
    "mombasa",
  ],
  Tshiluba: [
    "tshiluba",
    "luba",
    "kasai",
    "congo",
    "drc",
    "dr congo",
    "congo-kinshasa",
  ],
  Wolof: ["wolof", "senegal", "gambia", "mauritania", "dakar"],
  Yemba: [
    "yemba",
    "bamileke",
    "west",
    "cameroon",
    "dschang",
  ],
  "Yoruba (Audio)": [
    "yoruba",
    "nigeria",
    "benin",
    "togo",
    "southwest nigeria",
    "lagos",
  ],
  "Zulu (Audio)": [
    "zulu",
    "isizulu",
    "south africa",
    "kwazulu-natal",
    "kzn",
  ],
};

export { languageMetadata };
